export const SHOW_SPINNER = 'SHOW_SPINNER';

export const SET_AUTH_USER = 'SET_USER';
export const SET_AUTH_TOKEN = 'SET_TOKEN';

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTH_ROLE = 'SET_AUTH_ROLE';

export const SET_SESSION_START = 'SET_SESSION_START';
export const USER_LOGOUT = 'USER_LOGOUT';
